export default __webpack_public_path__ + "static/media/757.52eacf90.jpg";